module.exports = __webpack_public_path__ + "static/img/pro4.500928ce.jpg";